export const SM = "640px";
export const MD = "768px";
export const LG = "1024px";
export const XL = "1280px";
export const XL2 = "1536px";
